import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/rules-res/pic01.jpg'
import _imports_1 from '@/assets/imgs/rules-res/big_eye_chart.jpg'
import _imports_2 from '@/assets/imgs/rules-res/big_eye_chart02.jpg'
import _imports_3 from '@/assets/imgs/rules-res/big_eye_chart03.jpg'
import _imports_4 from '@/assets/imgs/rules-res/big_eye_redchart01.jpg'
import _imports_5 from '@/assets/imgs/rules-res/big_eye_redchart02.jpg'
import _imports_6 from '@/assets/imgs/rules-res/big_eye_redchart03.jpg'
import _imports_7 from '@/assets/imgs/rules-res/small_eye_chart01.jpg'
import _imports_8 from '@/assets/imgs/rules-res/small_eye_chart02.jpg'
import _imports_9 from '@/assets/imgs/rules-res/small_eye_chart03.jpg'
import _imports_10 from '@/assets/imgs/rules-res/small_eye_redchart01.jpg'
import _imports_11 from '@/assets/imgs/rules-res/small_eye_redchart02.jpg'
import _imports_12 from '@/assets/imgs/rules-res/small_eye_redchart03.jpg'
import _imports_13 from '@/assets/imgs/rules-res/cockroach_chart01.jpg'
import _imports_14 from '@/assets/imgs/rules-res/cockroach_bluechart01.jpg'
import _imports_15 from '@/assets/imgs/rules-res/cockroach_bluechart02.jpg'
import _imports_16 from '@/assets/imgs/rules-res/cockroach_redchart01.jpg'
import _imports_17 from '@/assets/imgs/rules-res/cockroach_redchart02.jpg'
import _imports_18 from '@/assets/imgs/rules-res/cockroach_redchart03.jpg'
import _imports_19 from '@/assets/imgs/rules-res/ask_1.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-fb86182c")

_pushScopeId("data-v-fb86182c")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "dialog-body" }
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = { class: "tab-pane" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "tab-pane-body" }, [
  /*#__PURE__*/_createVNode("div", { class: "rules" }, [
    /*#__PURE__*/_createVNode("p", { class: "toptitle" }, "百家乐:"),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "简介:"),
    /*#__PURE__*/_createVNode("p", null, " 长期以来，百家乐是亚洲、欧洲和拉丁美洲最受欢迎的游戏之一，玩法简单，却刺激紧张! "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "如何胜出:"),
    /*#__PURE__*/_createVNode("p", null, " 百家乐中将发两份牌<<庄家>> 和<<闲家>>，总数得9点或最接近9 点的一家胜出。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "操作及下注指南:"),
    /*#__PURE__*/_createVNode("p", null, " 1. 点击下注的筹码，再点击桌上下注任何一块( 闲家、庄家或平局)。 "),
    /*#__PURE__*/_createVNode("p", null, " 2. 闲家和庄家将获发两张牌，加起来等於10作0点，总和超过9，则只算总数中的个位。 "),
    /*#__PURE__*/_createVNode("p", null, " 3. 任何一家拿到8或9点（天生赢家），牌局就算结束，不再补牌。 "),
    /*#__PURE__*/_createVNode("p", null, " 4. 派出两张牌後，如果任何一手牌的头两张牌的牌面为0至7，将依照补牌规则多发一张牌，不可以任选补牌。 "),
    /*#__PURE__*/_createVNode("p", null, "5. 没有任何一手牌获得超过三张牌。"),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "游戏玩法:"),
    /*#__PURE__*/_createVNode("p", null, " 本游戏采用8副牌（每副牌52张）来进行，游戏牌数合计416张。“闲家”“庄家”各先派两张牌，以“闲家”先发，如第一轮未分出胜负需再按“牌例”发第二轮的牌，最多每方3张牌，谁最接近9点即为胜方，而相同点数即和局 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "游戏规则:"),
    /*#__PURE__*/_createVNode("p", { class: "tabletitle" }, "1.点数计算"),
    /*#__PURE__*/_createVNode("table", null, [
      /*#__PURE__*/_createVNode("tbody", null, [
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, "牌面"),
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, "点数")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "2 至 9"),
          /*#__PURE__*/_createVNode("td", null, "根据其数值显示的点数")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "Ace"),
          /*#__PURE__*/_createVNode("td", null, "1")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "K 或 Q 或 J 或 10"),
          /*#__PURE__*/_createVNode("td", null, "0")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("p", null, " *当任何一家头两张牌的点数总和为8或9，就称为(天生赢家)。 "),
    /*#__PURE__*/_createVNode("p", null, " *派出两张牌後，如果需要补牌，将依照博牌规则向需要补牌方多发一张牌 "),
    /*#__PURE__*/_createVNode("p", null, "例子:"),
    /*#__PURE__*/_createVNode("p", null, "4 + 2 + 6 = 2"),
    /*#__PURE__*/_createVNode("p", null, "5 + 6 + 8 = 9"),
    /*#__PURE__*/_createVNode("p", null, "10 + 10 + 10 = 0"),
    /*#__PURE__*/_createVNode("p", { class: "tabletitle" }, "2.补牌规则:"),
    /*#__PURE__*/_createVNode("table", null, [
      /*#__PURE__*/_createVNode("tbody", null, [
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, " 闲两牌合计点数 "),
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, "(闲家)"),
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, " 庄两牌合计点数 "),
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, "(庄家)")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "0"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌"),
          /*#__PURE__*/_createVNode("td", null, "0"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "1"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌"),
          /*#__PURE__*/_createVNode("td", null, "1"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "2"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌"),
          /*#__PURE__*/_createVNode("td", null, "2"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "3"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌"),
          /*#__PURE__*/_createVNode("td", null, "3"),
          /*#__PURE__*/_createVNode("td", null, " 若闲家博得第三张牌是8点，庄家不得博牌 ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "4"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌"),
          /*#__PURE__*/_createVNode("td", null, "4"),
          /*#__PURE__*/_createVNode("td", null, " 若闲家博得第三张牌是0，1，8，9点， 庄家不得博牌 ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "5"),
          /*#__PURE__*/_createVNode("td", null, "必须博牌"),
          /*#__PURE__*/_createVNode("td", null, "5"),
          /*#__PURE__*/_createVNode("td", null, " 若闲家博得第三张牌是0，1，2，3，8，9点， 庄家不得博牌 ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "6"),
          /*#__PURE__*/_createVNode("td", null, "不得博牌"),
          /*#__PURE__*/_createVNode("td", null, "6"),
          /*#__PURE__*/_createVNode("td", null, " 若闲家博得第三张牌是6 或 7点，庄家必须博牌 ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "7"),
          /*#__PURE__*/_createVNode("td", null, "不得博牌"),
          /*#__PURE__*/_createVNode("td", null, "7"),
          /*#__PURE__*/_createVNode("td", null, "不得博牌")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "8"),
          /*#__PURE__*/_createVNode("td", null, "例牌，即定胜负"),
          /*#__PURE__*/_createVNode("td", null, "8"),
          /*#__PURE__*/_createVNode("td", null, "例牌，即定胜负")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "9"),
          /*#__PURE__*/_createVNode("td", null, "例牌，即定胜负"),
          /*#__PURE__*/_createVNode("td", null, "9"),
          /*#__PURE__*/_createVNode("td", null, "例牌，即定胜负")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("p", null, " *庄闲任何一方两牌合计8、9点为例牌，对方不须博牌，即定胜负。庄闲两方头两张牌各得6或7点，即和局。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "派彩赔率:"),
    /*#__PURE__*/_createVNode("p", { class: "tabletitle" }, " 本游戏为玩家提供百家乐玩法和免佣百家乐玩法。这两种玩法的博牌规则和投注种类一致，但投注庄的派彩方式有区别。其投注种类与派彩分别如下∶ "),
    /*#__PURE__*/_createVNode("p", { class: "tabletitle" }, "百家乐:"),
    /*#__PURE__*/_createVNode("table", null, [
      /*#__PURE__*/_createVNode("tbody", null, [
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, " 投注项目 "),
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, "赔率")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "闲家"),
          /*#__PURE__*/_createVNode("td", null, " 1 ：1 (开和局时退回下注金额) ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "庄家"),
          /*#__PURE__*/_createVNode("td", null, " 1 ：0.95 (开和局时退回下注金额) ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "和局"),
          /*#__PURE__*/_createVNode("td", null, "1 ：8")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "闲对子"),
          /*#__PURE__*/_createVNode("td", null, "1 ：11")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "庄对子"),
          /*#__PURE__*/_createVNode("td", null, "1 ：11")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "超级六"),
          /*#__PURE__*/_createVNode("td", null, "1：12")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "龙七"),
          /*#__PURE__*/_createVNode("td", null, "1 ：40")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "熊猫8"),
          /*#__PURE__*/_createVNode("td", null, "1 ：25")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "大老虎"),
          /*#__PURE__*/_createVNode("td", null, "1 ：50")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "小老虎"),
          /*#__PURE__*/_createVNode("td", null, "1 ：22")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("p", { class: "tabletitle" }, "免水百家乐:"),
    /*#__PURE__*/_createVNode("table", null, [
      /*#__PURE__*/_createVNode("tbody", null, [
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, " 投注项目 "),
          /*#__PURE__*/_createVNode("th", { class: "spetitle" }, "赔率")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "闲家"),
          /*#__PURE__*/_createVNode("td", null, " 1 ：1 (开和局时退回下注金额) ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "庄家"),
          /*#__PURE__*/_createVNode("td", null, " 1 ：1 (如庄以6点取胜，则赔一半；开和局时退回下注金额) ")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "和局"),
          /*#__PURE__*/_createVNode("td", null, "1 ：8")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "闲对子"),
          /*#__PURE__*/_createVNode("td", null, "1 ：11")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "庄对子"),
          /*#__PURE__*/_createVNode("td", null, "1 ：11")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "超级六"),
          /*#__PURE__*/_createVNode("td", null, "1：12")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "龙七"),
          /*#__PURE__*/_createVNode("td", null, "1 ：40")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "熊猫8"),
          /*#__PURE__*/_createVNode("td", null, "1 ：25")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "大老虎"),
          /*#__PURE__*/_createVNode("td", null, "1 ：50")
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "小老虎"),
          /*#__PURE__*/_createVNode("td", null, "1 ：22")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "特殊投注说明:"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode("• "),
      /*#__PURE__*/_createVNode("b", null, "超级六："),
      /*#__PURE__*/_createTextVNode("庄家以合计6点胜出。")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" • "),
      /*#__PURE__*/_createVNode("b", null, "龙七："),
      /*#__PURE__*/_createTextVNode("庄家必为3张牌，且点数合计为7点，庄家赢。 ")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" • "),
      /*#__PURE__*/_createVNode("b", null, "熊猫8："),
      /*#__PURE__*/_createTextVNode("闲家必为3张牌，且点数合计为8点，闲家赢。 ")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" • "),
      /*#__PURE__*/_createVNode("b", null, "大老虎："),
      /*#__PURE__*/_createTextVNode("庄家必为3张牌，且点数合计为6点，庄家赢。 ")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" • "),
      /*#__PURE__*/_createVNode("b", null, "小老虎："),
      /*#__PURE__*/_createTextVNode("庄家必为2张牌，且点数合计为6点，庄家赢。 ")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, " 备注：每靴第35局以后不接受龙七、熊猫8、大老虎、小老虎投注。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, " 备注：每局超级6不可和大老虎、小老虎同时投注。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "庄/闲对子:"),
    /*#__PURE__*/_createVNode("p", null, " 庄的第一张和第二张牌点数相同，则为庄对子。闲的第一张和第二张牌点数相同，则为闲对子。 "),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "例牌定义：首两牌结果为8或9点")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "非例牌定义：例牌之外的所有情况")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "请注意 :"),
    /*#__PURE__*/_createVNode("p", null, " • 荷官发牌时，偶有系统无法判读状况时，此时荷官将重新扫描，直到系统能够完整判读(如遇故障因素将注销所有相关注单/派彩)。 "),
    /*#__PURE__*/_createVNode("p", null, " • 如遇结算错误，按照当期视频结果重新结算。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "牌路介紹:"),
    /*#__PURE__*/_createVNode("p", null, " 「路」的意思，是百家樂開牌的結果記錄。 "),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_0,
        alt: "“牌路介绍”",
        class: "pic01"
      })
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "一、开牌结果的纪录:"),
    /*#__PURE__*/_createVNode("p", null, " 红色珠为庄，蓝色珠为闲, 绿色珠为和，红点在珠的左上角代表庄对，蓝点在珠的右下角代表闲对，如果同时出现庄对和闲对，则左珠的上角和右下角标示红点和蓝点。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "二、大路:"),
    /*#__PURE__*/_createVNode("p", null, " 红圈为庄，蓝圈为闲, 庄一列, 闲一列, 序排列出, 如果和的话, 会用一条绿色斜线代表，如果之后连续出现和，便用绿色数字代替。 "),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "三、大眼路:"),
    /*#__PURE__*/_createVNode("p", null, " 大眼路是根据大路延伸出来，从大路的第2列第2行开始分析出来，若那位置没有结果，则以大路的第3列第1行开始分析。 "),
    /*#__PURE__*/_createVNode("p", null, "如下图:"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_1,
        alt: "“牌路介绍”",
        class: "big_eye_chart"
      })
    ]),
    /*#__PURE__*/_createVNode("p", null, " 先从座标1(第2列第2行)分析，若座标1无庄或闲，则以座标2(第3列第1行)开始分析。 "),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "● 大眼路画蓝圈规则:")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "chart_bk" }, [
      /*#__PURE__*/_createVNode("div", { class: "chart01" }, [
        /*#__PURE__*/_createVNode("p", null, "1. 向下"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_2,
            alt: "“牌路介绍”",
            class: "big_eye_chart02"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前一列作对比，如无结果，则于大眼路画蓝圈。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, "2. 换列"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_3,
            alt: "“牌路介绍”",
            class: "big_eye_chart03"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前二列结果位置是不齐整，则于大眼路画蓝圈。 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "● 大眼路写法画红圈规则:")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "chart_bk" }, [
      /*#__PURE__*/_createVNode("div", { class: "chart01" }, [
        /*#__PURE__*/_createVNode("p", null, "1. 向下"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_4,
            alt: "“牌路介绍”",
            class: "big_eye_redchart01"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前一列作对比，不论结果为庄或闲，则于大眼路画红圈。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, " "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_5,
            alt: "“牌路介绍”",
            class: "big_eye_redchart02"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前一列作对比，如前一列的前二行或以上都无结果，则于大眼路画红圈。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, "2. 换列"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_6,
            alt: "“牌路介绍”",
            class: "big_eye_redchart03"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前二列结果位置是齐整，则于大眼路画红圈。 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "四、小路:"),
    /*#__PURE__*/_createVNode("p", null, " 小路是根据大路延伸出来，从大路的第3列第2行开始分析出来，若那位置没有结果，则以大路的第4列第1行开始分析 "),
    /*#__PURE__*/_createVNode("p", null, "如下图:"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_7,
        alt: "“牌路介绍”",
        class: "small_eye_chart01"
      })
    ]),
    /*#__PURE__*/_createVNode("p", null, " 先从座标1(第3列第2行)分析，若座标1无庄或闲，则以座标2(第4列第1行)开始分析。 "),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "● 小路写法画蓝圈规则:")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "chart_bk" }, [
      /*#__PURE__*/_createVNode("div", { class: "chart01" }, [
        /*#__PURE__*/_createVNode("p", null, "1. 向下"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_8,
            alt: "“牌路介绍”",
            class: "small_eye_chart02"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前二列作对比，如无结果，则于小眼路画蓝点。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, "2. 换列"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_9,
            alt: "“牌路介绍”",
            class: "small_eye_chart03"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前三列结果位置是不齐整，则于小路画蓝点。 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "● 小路写法画红圈规则:")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "chart_bk" }, [
      /*#__PURE__*/_createVNode("div", { class: "chart01" }, [
        /*#__PURE__*/_createVNode("p", null, "1. 向下"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_10,
            alt: "“牌路介绍”",
            class: "small_eye_redchart01"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前一列作对比，不论结果为庄或闲，则于大眼路画红点。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, " "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_11,
            alt: "“牌路介绍”",
            class: "small_eye_redchart02"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前一列作对比，如前二列的前二行或以上都无结果，则于大眼路画红点。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, "2. 换列"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_12,
            alt: "“牌路介绍”",
            class: "small_eye_redchart03"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前三列结果位置是齐整，则于大眼路画红点。 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "五、小强路:"),
    /*#__PURE__*/_createVNode("p", null, " 小路是根据大路延伸出来，从大路的第4列第2行开始分析出来，若那位置没有结果，则以大路的第5列第1行开始分析 "),
    /*#__PURE__*/_createVNode("p", null, "如下图:"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_13,
        alt: "“牌路介绍”",
        class: "cockroach_chart01"
      })
    ]),
    /*#__PURE__*/_createVNode("p", null, " 先从座标1(第4列第2行)分析，若座标1无庄或闲，则以座标2(第5列第1行)开始分析。 "),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "● 小强路画蓝色斜线规则:")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "chart_bk" }, [
      /*#__PURE__*/_createVNode("div", { class: "chart01" }, [
        /*#__PURE__*/_createVNode("p", null, "1. 向下"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_14,
            alt: "“牌路介绍”",
            class: "cockroach_bluechart01"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前三列作对比，如无结果，则于大眼路画蓝色斜线。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, "2. 换列"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_15,
            alt: "“牌路介绍”",
            class: "cockroach_bluechart02"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前四列结果位置是不齐整，则于大眼路蓝色斜线。 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("b", null, "● 小强路画红色斜线规则:")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "chart_bk" }, [
      /*#__PURE__*/_createVNode("div", { class: "chart01" }, [
        /*#__PURE__*/_createVNode("p", null, "1. 向下"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_16,
            alt: "“牌路介绍”",
            class: "cockroach_redchart01"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，水平方式跟前三列作对比，不论结果为庄或闲，则于大眼路画红色斜线。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, " "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_17,
            alt: "“牌路介绍”",
            class: "cockroach_redchart02"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前四列结果位置是不齐整，则于大眼路蓝色斜线。 ")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "chart02" }, [
        /*#__PURE__*/_createVNode("p", null, "2. 换列"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_18,
            alt: "“牌路介绍”",
            class: "cockroach_redchart03"
          })
        ]),
        /*#__PURE__*/_createVNode("p", null, " 以大路最新的结果，如比对前一列与前三列结果位置是齐整，则于大眼路画红色斜线。 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("p", { class: "title" }, "六、庄问路、闲问路:"),
    /*#__PURE__*/_createVNode("p", null, " 此功能是模拟下一局如果开庄或闲时，大路、大眼路、小路、小强路的结果。令玩家更方便及快速地判断该如何投注下一局。 "),
    /*#__PURE__*/_createVNode("p", null, "如下图:"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_19,
        alt: "“牌路介绍”",
        class: "ask_1"
      })
    ])
  ])
], -1)
const _hoisted_8 = { class: "tab-pane" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"tab-pane-body\" data-v-fb86182c><div class=\"rules\" data-v-fb86182c><p class=\"toptitle\" data-v-fb86182c>龙虎:</p><p class=\"title\" data-v-fb86182c>简介:</p><p data-v-fb86182c> 一个以牌面点数大小来决定输赢的博彩游戏，简单易学，让玩家完全体验赌场的趣味! </p><p class=\"title\" data-v-fb86182c>如何胜出:</p><p data-v-fb86182c> 正确预计两家&lt;&lt;龙&gt;&gt; 和&lt;&lt;虎&gt;&gt; 的点数比较大。 </p><p class=\"title\" data-v-fb86182c>操作及下注指南:</p><p data-v-fb86182c> 1. 点击下注的筹码，再点击桌上下注任何一块 ( 龙、虎或平局 )。 </p><p data-v-fb86182c> 2. 荷官只派两门牌，每门各派一只牌，即龙与虎，双方斗大。 </p><p class=\"title\" data-v-fb86182c>游戏规则:</p><p data-v-fb86182c> 1. 牌面先比点数，K为最大牌，A为最小。如点数相同，则比较花色，黑桃＞红桃＞梅花＞方片。 </p><p data-v-fb86182c> 2. 荷官先派发第一张牌于龙的位置，而第二张牌派发到虎的位置，点数较大的胜出，点数相同花色大的胜出。 </p><p class=\"title\" data-v-fb86182c>派彩赔率:</p><table data-v-fb86182c><tbody data-v-fb86182c><tr data-v-fb86182c><th class=\"spetitle\" data-v-fb86182c> 投注项目 </th><th class=\"spetitle\" data-v-fb86182c>赔率</th></tr><tr data-v-fb86182c><td data-v-fb86182c>龙</td><td data-v-fb86182c>1 ：1 (开和局时，全输)</td></tr><tr data-v-fb86182c><td data-v-fb86182c>虎</td><td data-v-fb86182c>1 ：1 (开和局时，全输)</td></tr><tr data-v-fb86182c><td data-v-fb86182c>和局</td><td data-v-fb86182c>1 ：10</td></tr></tbody></table><p class=\"title\" data-v-fb86182c>请注意:</p><p data-v-fb86182c> • 如遇结算错误，按照当期视频结果重新结算。 </p></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["rule-view-root", { mobile: _ctx.isMobile }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", null, _toDisplayString(_ctx.iN('setting.rule')), 1),
          _createVNode("span", {
            class: "icon-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.OnClickClose()))
          })
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", {
              class: ["tab-item", { active: _ctx.tabIndex === 0 }],
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabIndex = 0))
            }, _toDisplayString(_ctx.iN('common.baccarat')), 3),
            _createVNode("div", {
              class: ["tab-item", { active: _ctx.tabIndex === 1 }],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tabIndex = 1))
            }, _toDisplayString(_ctx.iN('common.dragontiger')), 3)
          ]),
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("div", _hoisted_6, [
              _hoisted_7
            ], 512), [
              [_vShow, _ctx.tabIndex === 0]
            ]),
            _withDirectives(_createVNode("div", _hoisted_8, [
              _hoisted_9
            ], 512), [
              [_vShow, _ctx.tabIndex === 1]
            ])
          ])
        ])
      ])
    ])
  ], 2))
})